import React from "react";
import { motion } from "framer-motion";
import { Zap, Crosshair, TrendingUp } from "lucide-react"; // אייקונים מתאימים

export default function BenefitsSection() {
  const benefits = [
    {
      icon: Zap,
      title: "Find Your Dream Job Faster",
      description: "Stop wasting time on endless searches. Our smart AI finds the perfect jobs for your skills and career goals in minutes.",
      iconColor: "text-yellow-500",
      bgColor: "bg-yellow-50",
    },
    {
      icon: Crosshair,
      title: "Matches That Fit You Perfectly",
      description: "We scan thousands of jobs but only show you the ones that are a true match. Our AI gets to know you and ensures you land the right interviews.",
      iconColor: "text-blue-500",
      bgColor: "bg-blue-50",
    },
    {
      icon: TrendingUp,
      title: "Skyrocket Your Career",
      description: "With JobPool.ai, you’re not just finding a job—you’re building a future. We help you stand out to employers and aim for roles that take you to the next level.",
      iconColor: "text-green-500",
      bgColor: "bg-green-50",
    },
  ];

  return (
    <div id="benefits" className="py-16 md:py-24">
      <div className="text-center mb-16">
        <motion.span 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="px-4 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full inline-block mb-4"
        >
          BENEFITS
        </motion.span>
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-bold text-gray-900"
        >
          Why Choose JobPool.ai?
        </motion.h2>
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          viewport={{ once: true }}
          className="mt-4 text-2xl text-gray-600 max-w-2xl mx-auto"
        >
          Our AI Finds Your Perfect Job — Faster Than Ever
        </motion.p>
      </div>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {benefits.map((benefit, index) => (
            <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
                className="relative bg-[#f1f6fd] rounded-2xl shadow-sm p-6 hover:shadow-lg transition-all hover:-translate-y-1 hover:ring-1 hover:ring-blue-100 border border-transparent"
            >
              <div
                  className={`inline-flex items-center justify-center w-12 h-12 rounded-xl ${benefit.bgColor} transition-transform duration-300 group-hover:scale-110`}
              >
                <benefit.icon className={`w-6 h-6 ${benefit.iconColor}`} />
              </div>

              <h3 className="mt-5 text-xl font-semibold text-gray-900">
                {benefit.title}
              </h3>

              <p className="mt-2 text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </motion.div>
        ))}
      </div>
    </div>
  );
}
